<template>
    <div class="flex flex-col text-xs">
        <div
            v-if="label"
            class="font-normal"
        >
            <slot name="label">
                <div class="inline pr-1">{{ label }}</div>
            </slot>

            <CheckTextualResultContent v-if="value.text">
                <div class="inline break-words font-semibold">
                    {{ value.text }}
                </div>
            </CheckTextualResultContent>
        </div>
        <slot name="post-label-row"></slot>
        <CheckStateResult
            v-if="colorfulState && !value.suppressMatch"
            :value
            :with-state-icon
        />
        <CheckTextualResultContent v-if="!value.text">
            <slot />
        </CheckTextualResultContent>
    </div>
</template>

<script lang="ts" setup>
import { type CheckResult } from '@/api/interfaces/identity-verification-report.api';
import CheckStateResult from './CheckStateResult.vue';
import CheckTextualResultContent from './CheckTextualResultContent.vue';

defineSlots<{
    'post-label-row': () => null;
    label: () => null;
    default: () => unknown;
}>();

withDefaults(
    defineProps<{
        value: CheckResult;
        label?: string;
        colorfulState?: boolean;
        withStateIcon?: boolean;
    }>(),
    {
        colorfulState: false,
        withStateIcon: false,
    },
);
</script>
